//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import betting from '~/plugins/betting'
import { marketMatchesScope } from '~/utils/marketMatching'
import seguroEmpateMixin from '~/mixins/seguro-empate'
const querystring = require('querystring')
import structuredClone from '@ungap/structured-clone';

function toFixed(num, fixed = 2) {
  var re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?')
  return parseFloat(num.toString().match(re)[0])
}
export default {
  components: {},
  mixins: [seguroEmpateMixin],
  data() {
    return {
      max_win: 25000,
      max_odds_single_bet_frb: 8,
      max_win_reached: false,
      max_win_message: '',
      combo_boost_optin_message: '',
      tickets: [],
      insuredTickets: {},
      each_way: false,
      systemBetSelection: null,
      systemBetChoices: [],
      freebetOptions: [],
      freebetCode: '',
      config: {
        spinner: true,
        step: 1,
        min: 0,
        max: 1100,
        precision: 2,
        decimal: '.',
        thousands: ',',
        bootstrap: false,
        amend: false,
        masked: true
      },
      loading: false,
      combo_boost_number_null_percentage: 0,
      restrictedCombos: new Set(),
      checkingFreebetRestriction: false,
    }
  },
  props: ['mini'],
  watch: {
    freebet_enabled(newVal) {
      if (!newVal) {
        this.freebetCode = ''
      }
    },
    freebetRestrictionKey(newKey, oldKey) {
      if (newKey === oldKey) return
      if (newKey && this.freebetOptions.length) {
        this.checkFreebetRestrictions()
      } else {
        this.restrictedCombos = new Set()
      }
    },
    user(newUser, oldUser) {
      if (newUser && !oldUser) {
        this.fetchFreebets()
      } else if (!newUser) {
        this.freebetOptions = []
        this.restrictedCombos = new Set()
      }
    },
    selections(newSelections, oldSelections) {
      const newLen = _.size(newSelections);
      const oldLen = _.size(oldSelections);

      // 1. Early exit if size hasn't changed (unless you need deep watching)
      if (newLen === oldLen) return;

      // 2. Handle additions
      if (newLen > oldLen) {
        if (this.betType === 'single' && newLen > 1) {
          if (!this.hasDuplicateEventId(newSelections)) {
            this.selectBetType('combi');
          }
        }
      }

      // 3. System bet calculation
      if (this.betType === 'system') {
        this.calculateSystemBets();
      }

      // 4. Boundary enforcement (Single source of truth)
      if (newLen === 1) {
        this.selectBetType('single');
      } else if (this.betType === 'system' && (newLen <= 2 || newLen > 16)) {
        this.selectBetType('single');
      }
    },
    betType(newType) {
      if (newType === 'single' && this.freebetOptions.length && this.freebetRestrictionKey) {
        this.checkFreebetRestrictions()
      } else {
        this.restrictedCombos = new Set()
      }
    },
    freebetOptions(newVal) {
      if (newVal.length && this.betType === 'single' && this.freebetRestrictionKey) {
        this.checkFreebetRestrictions()
      } else if (!newVal.length) {
        this.restrictedCombos = new Set()
      }
    }
  },
  mounted() {
    if (this.combo_boost_config) {
      const percent_steps = this.combo_boost_config?.percent_steps || [0];
      this.combo_boost_number_null_percentage = 0;
      for (let i = 0; i < percent_steps.length; i++) {
        if (parseInt(percent_steps[i]) === 0) {
          this.combo_boost_number_null_percentage++
        }
      }
    }
    this.max_win_message = 'Las ganancias máximas alcanzables puede ser limitadas debido a nuestros términos y condiciones.'



    let lastUpdate = _.get(this.$store.state, 'betslip.updatedAt')
    // Ensure dayjs exists before use
    if (window.dayjs && lastUpdate && dayjs().diff(dayjs(lastUpdate), 'hour') > 24) {
      this.$store.commit('betslip/clear')
    }
    this.$store.commit('betslip/setError', null)

    if (this.betType === 'system') {
      this.selectBetType('system')
    }

    if (window.tock) {
      if (tock.active('betslip')) {
        tock.clear('betslip')
      }
      tock.setInterval('betslip', () => {
        this.updateSelections()
      }, 5000)
    }

    this.fetchFreebets()

    // Bind and store listeners for cleanup
    this._onSelectionAdded = () => this.updateSelections();
    this._onRefreshFreebets = () => this.fetchFreebets();
    this._onLoggedIn = () => this.fetchFreebets();

    this.$root.$on('selection_added', this._onSelectionAdded)
    this.$root.$on('refresh_freebets', this._onRefreshFreebets)
    this.$root.$on('logged_in', this._onLoggedIn)
  },
  beforeDestroy() {
    // Cleanup to prevent memory leaks
    this.$root.$off('selection_added', this._onSelectionAdded)
    this.$root.$off('refresh_freebets', this._onRefreshFreebets)
    this.$root.$off('logged_in', this._onLoggedIn)

    if (window.tock) {
      tock.clear('betslip')
    }
  },
  computed: {
    seguro_combinada_optin() {
      return this.$store.getters.seguroCombinadaOptedIn
    },
    combo_boost_ineligible_selection_ids() {
      if (this.betType !== 'combi' || !this.combo_boost_config) return new Set()
      const ids = new Set()
      for (const s of this.selections_live || []) {
        if (_.get(s, 'outcome.combo_boost_available') === false) {
          ids.add(_.get(s, 'outcome.id'))
        }
      }
      return ids
    },
    seguro_combinada_ineligible_selection_ids() {
      if (this.betType !== 'combi' || !this.seguro_combinada_config) return new Set()
      const minOdd = parseFloat(_.get(this.seguro_combinada_config, 'minimum_odds_per_selection', 0))
      const scopes = this.seguro_combinada_scopes
      const ids = new Set()
      for (const selection of this.selections || []) {
        if (!this.seguro_combinada_selection_eligible(selection, scopes, minOdd)) {
          ids.add(_.get(selection, 'outcome.id'))
        }
      }
      return ids
    },
    seguro_combinada_config() {
      return this.$store.getters.seguroCombinadaConfig
    },
    seguro_combinada_accept_not_eligible_legs() {
      return this.$store.getters.seguroCombinadaAcceptNotEligibleLegs
    },
    seguro_combinada_scopes() {
      const sportConfigs = _.get(this.seguro_combinada_config, 'sport_configs', [])
      return _.flatMap(sportConfigs, (sc) => sc.config || [])
    },

    seguro_combinada_has_ineligible_leg() {
      if (this.betType !== 'combi' || !this.seguro_combinada_config) return false
      return (this.selections || []).some((selection) => !this.seguro_combinada_selection_eligible(selection))
    },

    seguro_combinada_blocked() {
      return this.seguro_combinada_has_ineligible_leg && !this.seguro_combinada_accept_not_eligible_legs
    },

    seguro_combinada_qualifying_legs() {
      if (this.betType !== 'combi' || !this.seguro_combinada_config) return 0
      if (this.seguro_combinada_blocked) return 0
      return (this.selections || []).filter((selection) => this.seguro_combinada_selection_eligible(selection)).length
    },
    seguro_combinada_total() {
      return parseInt(_.get(this.seguro_combinada_config, 'minimum_selection_per_bet', 0))
    },
    seguro_combinada_active() {
      if (!this.seguro_combinada_config) return false
      if (this.seguro_combinada_blocked) return false

      const excludeFreebets = !!_.get(this.seguro_combinada_config, 'exclude_freebets', false)
      if (excludeFreebets && this.freebet) return false

      const minAmount = parseFloat(_.get(this.seguro_combinada_config, 'minimum_bet_amount', 0))
      const minTotalOdds = parseFloat(_.get(this.seguro_combinada_config, 'min_odd_total', 0))
      return this.seguro_combinada_qualifying_legs >= this.seguro_combinada_total &&
          parseFloat(this.total_stake) >= minAmount &&
          parseFloat(this.total_odds) >= minTotalOdds
    },
    seguro_combinada_notice() {
      if (!this.seguro_combinada_config) return false
      if (this.betType !== 'combi' || this.selections.length < 2) return false

      if (this.seguro_combinada_optin) {
        return true
      }

      return !this.seguro_combinada_active
    },
    seguro_combinada_show_progress() {
      return !this.seguro_combinada_blocked
    },
    seguro_combinada_notice_content() {
      if (this.seguro_combinada_active) return 'Seguro de Combinada activo'
      if (this.seguro_combinada_blocked) {
        const minOdd = parseFloat(_.get(this.seguro_combinada_config, 'minimum_odds_per_selection', 0))
        return `Todas las selecciones deben tener cuota ≥ ${minOdd.toFixed(2)} y estar en mercados elegibles`
      }
      if (_.get(this.seguro_combinada_config, 'exclude_freebets', false) && this.freebet) {
        return 'El Seguro de Combinada no está disponible al usar una Freebet'
      }

      const remaining = this.seguro_combinada_total - this.seguro_combinada_qualifying_legs
      if (remaining > 0) {
        return remaining === 1
            ? 'Añade 1 selección más para activar el Seguro de Combinada'
            : `Añade ${remaining} selecciones más para activar el Seguro de Combinada`
      }

      // Leg-count requirement already met — check the other two gates that
      // seguro_combinada_active also requires, so the message never goes
      // silent/nonsensical once remaining hits 0.
      const minAmount = parseFloat(_.get(this.seguro_combinada_config, 'minimum_bet_amount', 0))
      if (parseFloat(this.total_stake) < minAmount) {
        return `Aumenta tu apuesta a un mínimo de ${minAmount.toFixed(2)}€ para activar el Seguro de Combinada`
      }

      const minTotalOdds = parseFloat(_.get(this.seguro_combinada_config, 'min_odd_total', 0))
      if (parseFloat(this.total_odds) < minTotalOdds) {
        return `La cuota total debe ser de al menos ${minTotalOdds.toFixed(2)} para activar el Seguro de Combinada`
      }

      return ''
    },
    combo_boost_notice_content() {
      if (this.combo_boost_percentage > 0) {
        return 'Combo Boost activo'
      }
      const remaining = this.combo_boost_number_null_percentage - this.combo_boost_selections
      if (remaining <= 0) {
        return ''
      }
      return remaining === 1
          ? 'Añade 1 selección más para activar Combo Boost'
          : `Añade ${remaining} selecciones más para activar Combo Boost`
    },
    combo_boost_notice() {
      if (!this.combo_boost_config) return false
      if (this.betType !== 'combi' || this.selections.length < 2) return false

      if (this.combo_boost_optin) {
        return true
      }

      return this.combo_boost_percentage === 0
    },
    combo_boost_percentage() {
      if (!this.combo_boost_config) {
        return 0
      }
      const percent_steps = this.combo_boost_config?.percent_steps || [0];
      let boost_percentage = 0;
      for (let i = 0; i < percent_steps.length; i++) {
        if (this.combo_boost_selections >= i) {
          boost_percentage = parseInt(percent_steps[i]);
        }
      }
      return boost_percentage;
    },
    combo_boost_selections() {
      if (this.betType !== 'combi' || this.is_each_way) return 0;

      const seenEvents = new Set();
      const boostEvents = new Set();

      for (const s of this.selections_live || []) {
        const eventId = s?.event?.id;
        if (eventId == null) continue;

        seenEvents.add(eventId);

        if (s?.outcome?.combo_boost_available) boostEvents.add(eventId);
      }

      return boostEvents.size;
    },
    combo_boost_config() {
      return this.$store.state.settings.comboBoost
    },
    show_combo_boost_optin() {
      return !!(this.user && !this.combo_boost_optin && (this.combo_boost_percentage > 0));
    },
    combo_boost_optin() {
      if (!this.user) {
        return false;
      }
      return !!this.user.combo_boost_optin;
    },
    accept_odds() {
      return this.$store.state.settings.acceptOdds
    },
    lowest_odds() {
      return _.min(_.map(this.selections, 'outcome.odds'))
    },
    freebetRestrictionKey() {
      if (this.betType !== 'single' || this.selections.length !== 1) return null
      const odds = parseFloat(_.get(this.selections[0], 'outcome.odds', 0))
      if (odds > this.max_odds_single_bet_frb) return null
      const rawEventId = _.get(this.selections[0], 'event.id')
      const marketIds = _.uniq(_.map(_.get(this.selections[0], 'market.outcomes', []), 'market_id'))
      if (!rawEventId || !marketIds.length) return null
      const eventId = String(rawEventId).includes('-') ? String(rawEventId).split('-')[1] : rawEventId
      return JSON.stringify([eventId, marketIds.sort()])
    },
    freebet_restricted() {
      return this.restrictedCombos.has(this.freebetRestrictionKey)
    },
    freebet_enabled() {
      if (this.freebetOptions && this.freebetOptions.length) {
        if (this.betType === 'system') {
          return false;
        }
        if (this.betType === 'single') {
          if (this.selections.length !== 1) return false;
          if (this.checkingFreebetRestriction) return false;
          if (_.get(this.selections[0], 'outcome.is_each_way')) return false;
          const odds = parseFloat(_.get(this.selections[0], 'outcome.odds', 0))
          if (odds > this.max_odds_single_bet_frb) return false;
          return true;
        }
        if (this.betType === 'combi') {
          if (this.is_each_way) return false;
          return true;
        }
        return false;
      }
      return false;
    },
    is_each_way() {
      if (!this.selections_contain_eachway) {
        return false
      }
      if (this.betType === 'single') {
        return false
      }
      return this.each_way
    },
    freebet() {
      if (this.betType === 'single' && this.selections.length === 1) {
        const odds = parseFloat(_.get(this.selections[0], 'outcome.odds', 0))
        if (odds > this.max_odds_single_bet_frb) return null
        if (_.get(this.selections[0], 'outcome.is_each_way')) return null
      }
      if (this.betType === 'single' && this.freebet_restricted) return null
      if (this.betType === 'single' && this.selections.length > 1) return null
      let freebet = _.find(this.freebetOptions, { id: parseInt(this.freebetCode) })
      if (freebet) return freebet
      return null
    },
    showResults() {
      if (this.processingStatus) return true
      return false
    },
    stakeSingle: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSingle
      },
      set(value) {
        this.$store.commit('betslip/setStakesBatch', value)
        this.$store.commit('betslip/setStakeSingle', value)
      }
    },
    stakeCombi: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeCombi
      },
      set(value) {
        this.$store.commit('betslip/setStakeCombi', value)
      }
    },
    stakeSystem: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSystem
      },
      set(value) {
        this.$store.commit('betslip/setStakeSystem', value)
      }
    },
    betType: {
      get() {
        return this.$store.state.betslip.betType
      },
      set(value) {
        this.$store.commit('betslip/setBetType', value)
      }
    },
    selectionsLive: {
      get() {
        return this.$store.state.betslip.selectionsLive
      },
      set(value) {
        this.$store.commit('betslip/setSelectionsLive', value)
      }
    },
    processingStatus: {
      get() {
        return this.$store.state.betslip.processingStatus
      },
      set(value) {
        this.$store.commit('betslip/setProcessingStatus', value)
      }
    },
    total_odds() {
      let total = 0
      if (this.betType === 'combi') {
        total = this.selections_live.reduce((accumulator, selection) => {
          let current_return = 0
          if (_.get(selection, 'outcome.has_ew') && this.is_each_way) {
            current_return = parseFloat(_.get(selection, 'outcome.odds')) + parseFloat(_.get(selection, 'outcome.place_odds'))
          } else {
            current_return = parseFloat(_.get(selection, 'outcome.odds'))
          }
          if(current_return == 0)
            current_return = 1
          return accumulator * current_return
        }, 1)
        total = this.$sportify().sportsbook.formatOdds(total, _.get(this.$store.state, 'settings.oddsFormat', 'decimal'))
      }

      return total
    },
    total_return() {
      let selections = this.selections_live
      let total_stake = this.total_stake
      let freebet_stake = 0
      let freebet_remaining = parseInt(_.get(this.freebet, 'amount_remaining')) / 100
      this.max_win_reached = false
      if (freebet_remaining) {
        total_stake = _.clone(freebet_remaining)
        freebet_stake = _.clone(freebet_remaining)
        console.log('freebet_remaining', freebet_remaining)
        if (total_stake <= freebet_remaining) {
          //freebet_stake = _.clone(total_stake)
        }
        if (total_stake > freebet_remaining) {
          //freebet_stake = total_stake - freebet_remaining
        }
        //freebet_stake = Math.max(0, freebet_stake)
        console.log('freebet_stake', freebet_stake)
      }
      let starting_price_count = selections.reduce((accumulator, selection) => {
        return accumulator + +_.get(selection, 'outcome.is_starting_price', 0)
      }, 0)
      if (starting_price_count > 0) {
        return '-'
      }
      let invalid_odds = selections.reduce((accumulator, selection) => {
        return accumulator * (parseInt(_.get(selection, 'outcome.odds', 0)) > 0 ? 1 : 0)
      }, 1)
      if (invalid_odds == 0) {
        return '-'
      }

      let total = 0
      if (this.betType === 'single') {
        total = selections.reduce((accumulator, selection) => {
          let current_return = 0
          let stake = parseFloat(_.get(this.$store.state.betslip, 'stakes.' + _.get(selection, 'outcome.id'), this.stakeSingle))
          if (_.isNaN(stake)) {
            stake = 0
          }
          if (freebet_remaining) {
            stake = total_stake
          }
          if (_.get(selection, 'outcome.is_each_way')) {
            let win_portion = parseFloat(_.get(selection, 'outcome.odds')) * stake;
            let place_portion = ((win_portion-stake) / parseFloat(_.get(selection, 'market.ew_price'))) + stake;
            console.log('place_portion', place_portion)
            current_return = win_portion + place_portion
            //current_return = parseFloat(_.get(selection, 'outcome.odds')) * stake + parseFloat(_.get(selection, 'outcome.place_odds')) * stake
          } else {
            current_return = parseFloat(_.get(selection, 'outcome.odds')) * stake
          }
          if (accumulator + current_return > this.max_win) {
            console.log('accumulator + current_return',accumulator + current_return)
            this.max_win_reached = true;
          }
          return accumulator + current_return
        }, 0)
      }
      if (this.betType === 'combi') {
        // console.log('--55--');
        let stake = _.clone(this.stakeCombi)
        if(this.is_each_way) {
           let win_portion = 0;
           let place_portion = 0;

            win_portion = selections.reduce((accumulator, selection) => {
              let current_return = parseFloat(_.get(selection, 'outcome.odds'))
              return accumulator * current_return
            }, 1)
            place_portion = selections.reduce((accumulator, selection) => {
              let odds = parseFloat(_.get(selection, 'outcome.odds'));
              let ew_price = parseFloat(_.get(selection, 'market.ew_price'));
              let current_return = ((odds-1)/ew_price) + 1;
              return accumulator * current_return
            }, 1)
            total = (win_portion * stake) + (place_portion * stake)
        } else {
          total = selections.reduce((accumulator, selection) => {
            let current_return = parseFloat(_.get(selection, 'outcome.odds'))
            return accumulator * current_return
          }, 1)

          if (freebet_remaining) {
            stake = freebet_remaining
          }
          total = total * stake
          if(this.combo_boost_percentage && this.combo_boost_optin) {
            const mode = _.get(this.combo_boost_config, 'winnings_calc_mode');
            if (mode === 'gross') {
              total = total + (total * (this.combo_boost_percentage / 100));
            } else if (mode === 'net') {
              total = total + ((total - stake) * (this.combo_boost_percentage / 100));
            }
          }
        }
      }
      if (this.betType === 'system') {
        let stake = _.clone(this.stakeSystem)
        if (freebet_remaining) {
          stake = toFixed(freebet_remaining / this.total_bets)
        }

        if(this.is_each_way) {
          total = _.get(this.systemBetSelection, 'potential_return', 0) * stake
        } else {
          total = _.get(this.systemBetSelection, 'potential_return', 0) * stake
        }
      }

      if (_.get(this.freebet, 'amount_remaining') > 0) {
        total = total - freebet_stake
      }

      //round
      total = -Math.round(-total * 100) / 100
      //total = Math.floor(total * 100) / 100
      if(total > this.max_win) {
        this.max_win_reached = true;
      }
      return total
    },
    can_place_bet() {
      for (let selection of this.selections) {
        //console.log('can_place_bet', selection);
        if (_.get(selection, 'error')) {
          return false
        }
        if (_.get(selection, 'market.is_suspended')) {
          return false
        }
      }

      if (_.get(this.user, 'balance') <= 0 && !this.freebet) {
        return false
      }
      if (this.total_stake <= 0) {
        if (_.get(this.freebet, 'amount_remaining') > 0) {
          return true
        }
        return false
      }
      return true
    },
    total_stake_display() {
      let total = this.total_stake
      if (this.is_each_way) {
        total = total * 2
      }
      if (_.get(this.freebet, 'amount_remaining')) {
        total = Math.max(0, total - _.get(this.freebet, 'amount_remaining') / 100)
        total = 0
      }
      return total
    },
    total_stake() {
      let total = this.stake
      if (this.betType === 'single') {
        total = this.selections.reduce((accumulator, selection) => {
          let stake = parseFloat(_.get(this.$store.state.betslip, 'stakes.' + _.get(selection, 'outcome.id'), this.stake))
          if (_.isNaN(stake)) {
            stake = 0
          }
          if (_.get(selection, 'outcome.is_each_way')) {
            stake = stake * 2
          }
          return accumulator + stake
        }, 0)
      }
      if (this.betType === 'combi') {
        total = this.stakeCombi
      }
      if (this.betType === 'system') {
        total = _.get(this.systemBetSelection, 'combinations', 0) * this.stakeSystem
      }

      return total
    },
    total_bets() {
      if (this.betType === 'single') {
        return _.size(this.$store.state.betslip.selections)
      }
      if (this.betType === 'combi') {
        return 1
      }
      if (this.betType === 'system') {
        return _.get(this.systemBetSelection, 'combinations', 0)
      }
    },
    selections_contain_eachway() {
      let has_ew = false
      this.selections.map((selection) => {
        if (_.get(selection, 'market.ew_place')) {
          has_ew = true
        } else {
          has_ew = false;
        }
      })
      return has_ew
    },
    selections_contain_only_eachway() {
      let has_ew = true
      this.selections.map((selection) => {
        if (_.get(selection, 'market.ew_place') && has_ew) {
          has_ew = true
        } else {
          has_ew = false;
        }
      })
      return has_ew
    },
    selections() {
      const selections = _.cloneDeep(this.$store.state.betslip.selections);
      const betType = this.betType;

      // Efficiently find duplicate event IDs
      const eventCounts = _.countBy(selections, 'event.id');
      const duplicate_events = new Set(
          Object.keys(eventCounts).filter(id => eventCounts[id] > 1)
      );

      selections.forEach((selection) => {
        selection.error = null;
        const eventId = _.get(selection, 'event.id');
        const marketType = _.get(selection, 'market.type', '');

        // Validation Logic
        if (betType === 'combi' || betType === 'system') {
          if (duplicate_events.has(String(eventId))) {
            selection.error = 'CANNOT_COMBINE';
          }
          if (marketType.includes("cast")) {
            selection.error = 'FORECAST_TRICAST_CANNOT_BE_COMBINED';
          }
        }

        // Live Data Sync
        if (this.selectionsLive) {
          const liveData = _.get(this.selectionsLive, selection.outcome.id);
          if (liveData) {
            selection.market.is_suspended = liveData.is_suspended;
          }
        }
      });

      return selections;
    },
    selections_live() {
      const selections = structuredClone(this.$store.state.betslip.selections);

      if (!this.selectionsLive || !Array.isArray(selections)) {
        return selections;
      }

      selections.forEach((selection) => {
        const outcomeId = _.get(selection, 'outcome.id');
        const liveData = _.get(this.selectionsLive, outcomeId);

        if (liveData && _.has(liveData, 'odds')) {
          if (selection.outcome) {
            selection.outcome.odds = liveData.odds;
            selection.outcome.combo_boost_available = liveData.combo_boost_available;
          }

          if (selection.market) {
            selection.market.is_suspended = liveData.is_suspended;
          }
        }
      });

      return selections;
    },
    error() {
      return this.$store.state.betslip.error
    },

    show_changed_odds_btn() {
      if (_.get(this.$store.state, 'settings.acceptOdds') === 'all') {
        return false
      }

      let selections = _.map(this.selections, function (selection) {
        return { id: _.get(selection, 'outcome.id'), odds: _.get(selection, 'outcome.odds'), display_odds: _.get(selection, 'outcome.display_odds') }
      })
      //selections = _.keyBy(selections, 'id')

      let selectionsLive = _.map(this.selectionsLive, function (selection) {
        return { id: selection.id, odds: selection.odds, display_odds: selection.display_odds }
      })
      selectionsLive = _.keyBy(selectionsLive, 'id')

      if (_.get(this.$store.state, 'settings.acceptOdds') === 'higher') {
        let decreases = _.filter(selections, (selection) => {
          if (parseFloat(_.get(selection, 'odds')) < parseFloat(_.get(selectionsLive, selection.id + '.odds'))) {
            return true
          }
          return false
        })
        if (_.size(decreases) > 0) return true
      }

      if (_.get(this.$store.state, 'settings.acceptOdds') === 'none') {
        let changes = _.filter(selections, (selection) => {
          if (!_.get(selectionsLive, selection.id + '.odds')) {
            return false
          }
          if (_.get(selection, 'odds') == _.get(selectionsLive, selection.id + '.odds')) {
            return false
          }
          return true
        })
        if (_.size(changes) > 0) return true
      }

      return false
    }
  },
  methods:  {
    seguroCombinadaLineMessage(selection) {
      if (!this.seguro_combinada_notice || this.seguro_combinada_accept_not_eligible_legs) return null
      const reason = this.seguro_combinada_selection_reason(selection)
      if (!reason) return null
      return this.seguro_combinada_reason_message(reason)
    },

    selection_combo_boost_ineligible(selection) {
      return this.combo_boost_ineligible_selection_ids.has(_.get(selection, 'outcome.id'))
    },

    seguro_combinada_selection_reason(selection) {
      if (!this.seguro_combinada_config) return null
      const minOdd = parseFloat(_.get(this.seguro_combinada_config, 'minimum_odds_per_selection', 0))
      const liveOdds = parseFloat(_.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.odds', _.get(selection, 'outcome.odds', 0)))

      if (liveOdds < minOdd) return 'odds'

      const eventType = _.get(this.seguro_combinada_config, 'event_type', 'both')
      const isLive = !!_.get(selection, 'event.is_live')
      if (eventType === 'pre-match' && isLive) return 'event_type'
      if (eventType === 'live' && !isLive) return 'event_type'

      const sportId = _.get(selection, 'event.sport_id')
      const sportSlug = _.get(selection, 'event.sport_slug')
      const providerCompetitionId = _.get(selection, 'event.competition_id')
      const eventId = _.get(selection, 'event.id')
      const marketTypeId = _.get(selection, 'market.market_type')

      let candidates = this.seguro_combinada_scopes

      candidates = candidates.filter((scope) => {
        if (scope.provider_sport_id && scope.provider_sport_id !== sportId) return false
        if (scope.sport_id && String(scope.sport_id).toLowerCase() !== String(sportSlug).toLowerCase()) return false
        return true
      })
      if (candidates.length === 0) return 'sport'

      candidates = candidates.filter((scope) => {
        if (scope.provider_competition_id && scope.provider_competition_id !== providerCompetitionId) return false
        return true
      })
      if (candidates.length === 0) return 'competition'

      candidates = candidates.filter((scope) => {
        if (scope.event_id && scope.event_id !== eventId) return false
        return true
      })
      if (candidates.length === 0) return 'event'

      candidates = candidates.filter((scope) => marketMatchesScope(marketTypeId, scope))
      if (candidates.length === 0) return 'market'

      return null
    },

    seguro_combinada_selection_eligible(selection) {
      return this.seguro_combinada_selection_reason(selection) === null
    },

    seguro_combinada_reason_message(reason) {
      const messages = {
        odds: `No válida para el seguro: cuota inferior a ${parseFloat(_.get(this.seguro_combinada_config, 'minimum_odds_per_selection', 0)).toFixed(2)}`,
        event_type: 'No válida para el seguro: tipo de evento no permitido',
        sport: 'No válida para el seguro: deporte no incluido en la promoción',
        competition: 'No válida para el seguro: competición no incluida en la promoción',
        event: 'No válida para el seguro: evento no incluido en la promoción',
        market: 'No válida para el seguro: mercado no elegible'
      }
      return messages[reason] || ''
    },

    hasDuplicateEventId(selections) {
      const seen = new Set();
      for (const s of selections) {
        const id = s?.event?.id;
        if (id == null) continue;
        if (seen.has(id)) return true;
        seen.add(id);
      }
      return false;
    },
    toggleEachway() {
      this.each_way = !this.each_way;
      if (this.betType === 'system') {
        this.calculateSystemBets();
      }
    },
    changeEW() {
      console.log('is_each_way', this.is_each_way)
      if (this.betType === 'system') {
        this.calculateSystemBets()
      }
    },
    async fetchFreebets() {
      if (!this.user) {
        this.freebetOptions = [];
        this.$store.commit('setFreebetCount', _.size(this.freebetOptions))
        return false
      }

      try {
        const response = await this.$api().get('api/content/freebets/active', { params: { active: true, bookmaker: process.env.BOOKMAKER } })
        const freebets = _.get(response.data, 'data', [])
        const activeBonuses = this.$store.state.active_bonuses || []

        this.freebetOptions = freebets.filter(freebet => activeBonuses.includes(freebet.id))

        this.$store.commit('setFreebetCount', _.size(this.freebetOptions))
      } catch (e) {
        this.$notyf.error('Something went wrong!')
      }
    },
    changeStake(value) {
      this.$store.commit('betslip/clearStakes')
    },
    async calculateSystemBets() {
      // console.log('calculateSystemBets', _.map(this.selections_live, 'outcome.odds'));
      // console.log('calculateSystemBets selections_live', this.selections_live);
      betting.setSelections(this.selections_live)
      betting.setEachWay(this.is_each_way)
      this.systemBetChoices = betting.generateSystemBetTypes()
      if (!this.systemBetSelection || !_.includes(_.map(this.systemBetChoices, 'type'), _.get(this.systemBetSelection, 'type'))) {
        this.systemBetSelection = _.first(this.systemBetChoices)
      } else {
        this.systemBetSelection = _.find(this.systemBetChoices, { type: _.get(this.systemBetSelection, 'type') })
      }

      await this.systemBetSelected();
    },
    async selectBetType(betType) {
      // console.log('selectBetType', betType)

      if (this.selections.length < 2 && betType === 'combi') {
        this.systemBetSelection = null
        return
      }
      if (this.selections.length <= 2 && betType === 'system') {
        return
      }
      if (this.selections.length > 20 && betType === 'system') {
        await this.selectBetType('single')
        return
      }

      if (betType === 'system') {
        await this.calculateSystemBets()
        this.freebetCode = ''
      }
      this.betType = betType
    },
    async openSettings() {
      this.$modal.show('modal-settings')
    },
    async clear() {
      this.$store.commit('betslip/clear')
      this.$store.commit('betslip/setError', null)
    },
    async close() {
      this.$store.commit('betslip/toggleBetslip', false)
    },
    async closeResults() {
      this.processingStatus = false
    },
    async updateSelections() {
      if (_.isEmpty(this.selections)) {
        return null; // Silent exit if empty, or throw if you want to catch it
      }
      const params = {
        lang: this.lang,
        ids: _.map(this.selections, (item) => ({
          outcome_id: _.get(item, 'outcome.id'),
          event_id: _.get(item, 'event.id')
        }))
      };

      try {
        const response = await this.$sportify().sportsbook._getSelections(params);

        const selectionsArray = _.get(response, 'selections', []);
        this.selectionsLive = _.keyBy(selectionsArray, 'id');

        if (this.betType === 'system') {
          await this.calculateSystemBets();
        }

        return this.selectionsLive;
      } catch (error) {
        // Handle specific UI errors here if needed
        console.error("Betslip Update Failed:", error);
      }
    },
    async acceptOdds(force = false) {
      //go through all selections and change odds and display odds to match those of selectionsLive
      let selections = _.map(_.cloneDeep(this.selections), (selection) => {
        //console.log('acceptOdds', selection);
        if (force || this.accept_odds === 'all' || (this.accept_odds === 'higher' && _.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.odds') > _.set(selection, 'outcome.odds'))) {
          // console.log('acceptOdds--', _.get(selection, 'outcome.odds'));
          selection.outcome.odds = _.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.odds')
          selection.outcome.display_odds = _.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.display_odds')
          //selection = _.set(selection, 'outcome.odds', _.get(this.selectionsLive, _.get(selection, 'outcome.id') + '.odds'))
          //selection = _.set(selection, 'outcome.display_odds', _.get(this.selectionsLive, _.get(selection, '.id') + '.display_odds'))
        }
        return selection
      })
      this.$store.commit('betslip/setSelections', selections)
    },

    async linkSeguroEmpate(ticket, uuid) {
      const promotionId = this.seguro_empate_promotion_id
      if (!promotionId || !uuid || this.betType !== 'single') return

      if (_.size(_.get(ticket, 'selections', [])) !== 1) return

      // A freebet-funded bet never qualifies (Exclude Freebet Bets in the CMS).
      if (this.freebet) return

      const insuredMap = _.get(this.$store.state.betslip, 'insured', {})
      let insuredEventId = null
      let campaign = null
      const wasInsured = _.some(_.get(ticket, 'selections', []), (ticketSelection) => {
        const outcomeId = _.get(ticketSelection, 'outcome_id')
        if (!_.get(insuredMap, outcomeId)) return false

        const selection = _.find(this.selections, (s) => _.get(s, 'outcome.id') === outcomeId)
        if (!selection || !this.seguroEmpateSelectionQualifies(selection)) return false
        if (this.seguroEmpateEventAlreadyInsured(selection)) return false

        campaign = this.seguroEmpateCampaignFor(_.get(selection, 'event'))
        if (!campaign) return false

        insuredEventId = this.seguroEmpateEventId(_.get(selection, 'event'))
        return true
      })
      if (!wasInsured || !campaign) return
      try {
        await this.$new_cms().post(
            `/api/cms/promotions/promotion-bet?bet_id=${uuid}&promotion_id=${promotionId}&campaign_uuid=${campaign.uuid}`
        )
        this.$set(this.insuredTickets, uuid, true)
        // Mirror what the next /api/cms/promotions/insurances would report, so a
        // second bet on the same match is blocked without waiting for a refetch.
        this.$store.commit('addSeguroEmpateInsuredBetId', {
          campaignUuid: campaign.uuid,
          betId: uuid
        })
        if (insuredEventId) this.$store.commit('addSeguroEmpateInsuredEvent', insuredEventId)
      } catch (e) {
        console.error('Escudo777: failed to link insurance to bet', uuid, _.get(e, 'message'))
      }
    },

    /**
     * Escudo777 - Seguro de Empate: record the opt-in against the placed bet.
     */
    async linkSeguroEmpate1(ticket, uuid) {
      const promotionId = this.seguro_empate_promotion_id
      if (!promotionId || !uuid || this.betType !== 'single') return

      if (_.size(_.get(ticket, 'selections', [])) !== 1) return

      // A freebet-funded bet never qualifies (Exclude Freebet Bets in the CMS).
      if (this.freebet) return

      const insuredMap = _.get(this.$store.state.betslip, 'insured', {})
      let insuredEventId = null
      const wasInsured = _.some(_.get(ticket, 'selections', []), (ticketSelection) => {
        const outcomeId = _.get(ticketSelection, 'outcome_id')
        if (!_.get(insuredMap, outcomeId)) return false

        const selection = _.find(this.selections, (s) => _.get(s, 'outcome.id') === outcomeId)
        if (!selection || !this.seguroEmpateSelectionQualifies(selection)) return false
        if (this.seguroEmpateEventAlreadyInsured(selection)) return false

        insuredEventId = this.seguroEmpateEventId(_.get(selection, 'event'))
        return true
      })
      if (!wasInsured) return
      try {
        await this.$new_cms().post(
          `/api/cms/promotions/promotion-bet?bet_id=${uuid}&promotion_id=${promotionId}&campaign_uuid=${this.seguro_empate_campaign_uuid}`
        )
        this.$set(this.insuredTickets, uuid, true)
        // Mirror what the next /api/cms/promotions/insurances would report, so a
        // second bet on the same match is blocked without waiting for a refetch.
        this.$store.commit('addSeguroEmpateInsuredBetId', {
          hash: this.seguro_empate_campaign_hash,
          betId: uuid
        })
        if (insuredEventId) this.$store.commit('addSeguroEmpateInsuredEvent', insuredEventId)
      } catch (e) {
        console.error('Escudo777: failed to link insurance to bet', uuid, _.get(e, 'message'))
      }
    },

    async placeSingleBet(ticket) {
      //let stakes = _.cloneDeep(this.$store.state.betslip.stakes);
      //stakes = _.map(stakes, function(s){return s * 100});

      try {
        ticket.accept_odds =  _.get({'all': 'ACCEPT_ANY', 'higher': 'ACCEPT_HIGHER', 'none': 'ACCEPT_NONE'}, _.get(this.$store.state, 'settings.acceptOdds'))
        ticket.device_fingerprint = this.$store.state.deviceFingerprint
        ticket.lang = this.lang;
        const response = await this.$api().$post('/v1/betslip/submit', ticket)
        // console.log(response)
        this.freebetCode = ''
        if (_.get(response, 'status') == true) {
          this.tickets = _.map(this.tickets, (currentTicket) => {
            if (currentTicket.uuid == _.get(response, 'uuid')) {
              currentTicket.status = 'PROCESSED'
            }
            return currentTicket
          })

          //this.$store.commit('betslip/remove')
          //this.$swal(this.$t('Bet placed #' + _.get(response, 'id')))

          await this.linkSeguroEmpate(ticket, _.get(response, 'uuid') || _.get(ticket, 'uuid'))

          // console.log('update_balance')
          this.$root.$emit('update_balance')
          this.processingStatus = 'completed'
          /*setTimeout(() => {
            this.$store.commit('betslip/clear')
            this.$store.commit('betslip/clearStakes')
            this.$store.commit('betslip/setBetType', 'single')
            this.$store.commit('betslip/setStakeSingle', null)
            this.$store.commit('betslip/setStakeCombi', null)
          }, 1000)*/
        } else {
          this.tickets = _.map(this.tickets, (currentTicket) => {
            if (currentTicket.uuid == _.get(ticket, 'uuid')) {
              currentTicket.status = _.get(response, 'message', 'CONNECTION_ERROR')
              currentTicket.error = true;
              currentTicket.error_meta = _.get(response, 'meta.error')
            }
            // console.log('currentTicket', currentTicket);
            return currentTicket
          })
          //this.$store.commit('betslip/setError', _.get(response, 'error'))
        }
      } catch (e) {
        // console.log('placeSingleBet', e.response)
        this.tickets = _.map(this.tickets, (currentTicket) => {
          // console.log('ticket.uuid', currentTicket.uuid, _.get(e.response, 'data.uuid'))
          if (currentTicket.uuid === _.get(e.response, 'data.uuid')) {
            currentTicket.status = _.get(e.response, 'data.message', 'CONNECTION_ERROR')
            currentTicket.error_meta = _.get(e.response, 'data.meta.error')
            currentTicket.error = true;
          } else if(currentTicket.uuid === _.get(ticket, 'uuid')) {
            currentTicket.status = 'SERVER_ERROR';
            currentTicket.error_meta = 'Something went wrong';
            currentTicket.error = true;
          }
          return currentTicket
        })

      }

      await this.fetchFreebets()
      this.$root.$emit('update_freebets')
    },

    async systemBetSelected() {
      betting.setSelections(this.selections_live)
      this.systemBetChoices = betting.calculatePotentialReturn(this.systemBetChoices, this.systemBetSelection, this.each_way)
    },

    async placeBet() {
      await this.updateSelections()
      if (this.accept_odds === 'all' || this.accept_odds === 'higher') {
        await this.acceptOdds()
      }
      if (!this.user) {
        this.openLogin()
        return
      }

      this.$store.commit('betslip/setError', null)
      this.loading = true

      let selections = _.cloneDeep(this.selections)
      let stakes = _.cloneDeep(this.$store.state.betslip.stakes)
      stakes = _.each(stakes, (s, index) => {
        stakes[index] = this.$math().multiply(s, 100)
      })
      selections = _.map(selections, (selections) => {
        selections.stake = this.$math().multiply(selections.stake, 100)
        return selections
      })

      let simple_selections = _.map(selections, function (selections) {
        let item = {}
        item.event_id = _.get(selections, 'event.id')
        item.market_id = _.get(selections, 'outcome.market_id')
        item.outcome_id = _.get(selections, 'outcome.id')
        item.outcome_list = _.map(_.get(selections, 'outcome.items', []), 'id')
        item.odds = _.get(selections, 'outcome.odds')
        item.type = _.get(selections, 'market.type')
        item.each_way = _.get(selections, 'outcome.is_each_way')
        item.is_starting_price = _.get(selections, 'outcome.is_starting_price')
        item.stake = _.get(stakes, item.outcome_id, null)
        return item
      })

      this.$store.commit('betslip/setLastUsedStake', parseFloat(this.total_stake))

      try {
        let params = {
          freebet: _.get(this.freebet, 'id'),
          selections: simple_selections,
          type: this.betType,
          system_type: _.get(this.systemBetSelection, 'type'),
          total_stake: this.$math().multiply(this.total_stake, 100),
          total_bets: this.total_bets,
          total_return: this.total_return,
          each_way: this.is_each_way,
          stakes: stakes,
          lang: this.lang,
          accept_odds: _.get({'all': 'ACCEPT_ANY', 'higher': 'ACCEPT_HIGHER', 'none': 'ACCEPT_NONE'}, _.get(this.$store.state, 'settings.acceptOdds'))
        }

        if (this.betType === 'single') {
          params.stake = this.$math().multiply(this.stake, 100)
        }
        if (this.betType === 'combi') {
          params.stake = this.$math().multiply(this.stakeCombi, 100)
        }
        if (this.betType === 'system') {
          params.stake = this.$math().multiply(this.stakeSystem, 100)
        }

        // console.log('params', params)
        //
        // console.log('post axios', this.$axios.$post)
        // console.log('post api', this.$api().$post)
        this.cancelTokenSource = this.$axios.CancelToken.source()
        this.cancelTokenSource && this.cancelTokenSource.cancel('Operation canceled due to new request.');
        this.cancelTokenSource = this.$axios.CancelToken.source();
        const response = await this.$api().$post('/v1/betslip/calculate', params, {cancelToken: this.cancelTokenSource.token})
        // console.log('calculate', response)

        if (_.get(response, 'status') == true) {
          this.processingStatus = 'processing'
          this.tickets = _.get(response, 'tickets')
          this.insuredTickets = {}
          for (const ticket of _.get(response, 'tickets')) {
            // console.log('placeSingleBet', ticket)
            await this.placeSingleBet(ticket)
            // console.log('placeSingleBet', ticket)
          }
          // console.log('placeSingleBet DONE')
          this.processingStatus = 'completed'

        } else {
          this.$store.commit('betslip/setError', _.get(response, 'message'))
        }
      } catch (e) {
        console.log(e)
        let message = _.get(e, 'response.data.message', 'Oops, something went wrong. Please try again later.')
        this.$store.commit('betslip/setError', message)
      }

      await this.fetchFreebets()
      this.loading = false

    },

    async checkFreebetRestrictions() {
      const key = this.freebetRestrictionKey
      if (!this.user || !key) {
        this.restrictedCombos = new Set()
        this.checkingFreebetRestriction = false
        return
      }
      const [eventId, marketIds] = JSON.parse(key)

      this.checkingFreebetRestriction = true
      try {
        const response = await this.$new_cms().post('/api/sport/betslip/freebet-restrictions', {
          event_id: eventId,
          market_ids: marketIds
        })
        this.restrictedCombos = _.get(response.data, 'data.restricted', false)
            ? new Set([key])
            : new Set()
      } catch (e) {
        console.error('checkFreebetRestrictions failed', e)
        this.restrictedCombos = new Set()
      } finally {
        this.checkingFreebetRestriction = false
      }
    }
  }
}
